export const splitArrayInPieces = (array:Array<any>, amountPerPage:number) => {
    if(Array.isArray(array)){
        let r = array.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index/amountPerPage);

            if(!resultArray[chunkIndex]) {
                //Start new chunck
                resultArray[chunkIndex] = []
            }

            resultArray[chunkIndex].push(item);

            return resultArray
        }, [])

        return r;
    }
    else {
        return array;
    }
}